export class RestoreEFSRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "EFSRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreEFSRequest.attributeTypeMap;
    }
    constructor() {
    }
}
